import { API } from "../utils";

export const getCalendarEvents = async ({ params }) => {
  const response = API.get("/organization/calendar-events/", { params });
  const data = await response;
  return data;
};

export const getSingleCalendarEvent = async ({ params }) => {
  const response = API.get(`/organization/calendar-events/${params.id}/`);
  const data = await response;
  return data;
};

export const createCalendarEvent = async ({ params, body }) => {
  const response = API.post("/organization/calendar-events/", body);
  const data = await response;
  return data;
};

export const updateCalendarEvent = async ({ params, body }) => {
  const response = API.patch(
    `/organization/calendar-events/${params.id}/`,
    body
  );
  const data = await response;
  return data;
};

export const getCalendarExcel = async ({ params }) => {
  const response = API.get("/organization/calendar-events/excel/export", {
    params,
  });
  const data = await response;
  return data;
};

export const getCalendarICal = async ({ params }) => {
  const response = API.get("/organization/calendar-events/ical/export", {
    params,
  });
  const data = await response;
  return data;
};
